import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import { withFlags } from '../../../flags/Flags';

import {
  Badge,
  Button,
  Dropdown,
  Input
} from '@salesforce/design-system-react';

import './ImageRow.scss';

class ImageRow extends Component {
  getI18nID(suffix) {
    return `components.experiment.experimentWizard.${suffix}`;
  }

  renderDisableBadge() {
    const { formatMessage } = this.props.intl;
    if (this.props.selectable?.status === 'INACTIVE') {
      return (
        <Badge
          id="badge-base-example-inverse"
          color="inverse"
          content={formatMessage({ id: this.getI18nID('disabled') })}
        />
      );
    }
    return null;
  }

  renderDisableDropdown() {
    const { formatMessage } = this.props.intl;
    const toggleStatusLabel =
      this.props.selectable?.status === 'ACTIVE'
        ? formatMessage({ id: this.getI18nID('disableSelection') })
        : formatMessage({ id: this.getI18nID('enableSelection') });
    const disableDisable =
      this.props.selectable.status === 'ACTIVE' && !this.props.disableAllowed;
    const actions = [
      {
        label: toggleStatusLabel,
        value: 'disable'
      }
    ];
    return (
      <Dropdown
        assistiveText={{ icon: 'Image Options' }}
        buttonVariant="icon"
        iconCategory="utility"
        iconName="down"
        iconVariant="border-filled"
        align="right"
        buttonClassName="disable-dropdown"
        width="xx-small"
        options={actions}
        disabled={disableDisable}
        onSelect={() => this.props.onDisableSelectable()}
      />
    );
  }

  renderDeleteButton() {
    return (
      <Button
        className="delete-image-button"
        iconCategory="utility"
        iconName="delete"
        iconVariant="border-filled"
        variant="icon"
        onClick={this.props.onDeleteSelectable}
      />
    );
  }

  render() {
    const { formatMessage } = this.props.intl;
    const asset = this.props.selectable;
    let preview;
    let size = 0;
    if (asset.image_attributes?.image_url) {
      preview = asset.image_attributes?.image_url;
    } else if (asset.image_attributes?.image_data) {
      preview = asset.image_attributes?.image_data;
      const base64str = asset.image_attributes?.image_data?.split('base64,')[1]; //remove the image type metadata.
      size = Buffer.from(base64str, 'base64').length; //encode image into bytes
    } else {
      preview = asset.image_url;
    }
    let filePreviewError;
    if (size > 1024 * 1024) {
      filePreviewError = formatMessage({
        id: 'components.experiment.experimentWizard.imageTooBig'
      });
    } else {
      filePreviewError = null;
    }
    return withFlags(flags => (
      <div className="image-row">
        <div className="image-inputs slds-grid">
          <Button variant="base">
            <div
              className="thumbnail-container slds-col"
              style={{ backgroundImage: `url(${preview})` }}
            />
          </Button>
          <div className="slds-col">
            <Input
              key={`name-input-${asset.uuid}`}
              className="name-input"
              defaultValue={asset.name || ''}
              required={true}
              label={formatMessage({ id: this.getI18nID('fields.imageName') })}
              onChange={(_evt, { value }) =>
                this.props.onSelectableChange('name', value)
              }
            />
            <Input
              key={`url-input-${asset.uuid}`}
              className="url-input"
              defaultValue={asset.redirect_url || ''}
              required={true}
              label={formatMessage({ id: this.getI18nID('fields.url') })}
              onChange={(_evt, { value }) =>
                this.props.onSelectableChange('redirect_url', value)
              }
            />
            {this.props.status === 'DRAFT' || !asset.uuid
              ? this.renderDeleteButton()
              : this.renderDisableDropdown()}
            <p className="upload-error">{filePreviewError}</p>
          </div>
        </div>
        <div className="disable-badge slds-grid slds-col">
          {this.renderDisableBadge()}
        </div>
      </div>
    ));
  }
}

ImageRow.propTypes = {
  actions: PropTypes.object,
  selectable: PropTypes.object,
  disableAllowed: PropTypes.bool.isRequired,
  onSelectableChange: PropTypes.func.isRequired,
  onDeleteSelectable: PropTypes.func.isRequired,
  onDisableSelectable: PropTypes.func.isRequired,
  status: PropTypes.string,
  intl: intlShape.isRequired
};

export default injectIntl(ImageRow);
